/**
 * Vrai en recette, en préproduction ou en local (tests de développement) —
 * jamais en production. Gate d'exposition des fonctionnalités liées à
 * l'analyse IA ; miroir de `isAnalyseIaEnabled()` côté gateway. Liste blanche
 * volontaire : un nouvel environnement reste fermé par défaut.
 */
export const isRecette =
  import.meta.env.VITE_ENVIRONNEMENT === "recette" ||
  import.meta.env.VITE_ENVIRONNEMENT === "preproduction" ||
  import.meta.env.VITE_ENVIRONNEMENT === "local";
